function getStepResultText(title, percentage) {
    let text = {};
    const level = percentage < 25 ? 0 : percentage < 50 ? 1 : percentage < 75 ? 2 : 3;
    if (title === 'S&OP') {        
        switch (level) {
            case 0:
                text = {
                    level: "Iniciante",
                    result: `O conhecimento do processo S&OP na empresa ainda não foi desenvolvido. Sua empresa está iniciando a estruturação em processos, com poucas ferramentas práticas e teóricas que possam auxiliar os colaboradores nessa jornada.
                    `,
                    advice: `- Conscientizar a organização sobre os benefícios que podem ser atingidos para motivá-las a entrar nessas jornada;
                    - Capacitar a equipe em conceitos teóricos;
                    - Verificar a disponibilidade e qualidade das bases de dados para definição/refinamento dos parâmetros de planejamento do processo.
                    `,
                }
                break;
            case 1:
                text = {
                    level: "Rudimentar",
                    result: `A organização possui os conhecimentos básicos do processo S&OP e executa algumas atividades do processo, porém com muita informalidade. Portanto ainda é preciso estruturar e implementar o processo de forma clara e bem definida na empresa, estabelecendo uma conexão com as diretrizes estratégicas.
                    `,
                    advice: `-Formalizar as etapas do processo com os respectivos papéis e responsabilidades;
                    - Estruturação do processo na empresa, de forma que esse processo seja parte integrante de um ciclo geral da organização;
                    - Garantir que as informações fluam entre as etapas do processo e os mecanismos de decisão estejam vinculadas aos planos estratégicos;
                    - Estruturar a organização para compor uma equipe dedicada ao processo.
                    `,
                }
                break;
            case 2:
                text = {
                    level: "Clássico",
                    result: `A organização possui bom conhecimento do processo S&OP, com algumas etapas já definidas e outras com potencial de implementação na empresa. Deve investir em sua maturidade para simular cenários e integrar todas as ações táticas que impactam a demanda. Oportunidade de ampliar a colaboração entre as funções internas.
                    `,
                    advice: `- Obter a participação de todas as áreas relevantes para o processo;
                    - Priorizar as atividades do processo na agenda da organização;
                    - Garantir a qualidade das análises preparatórias e materiais utilizados nas reuniões;
                    - Desenvolver o senso crítico para extrair insights e identificar riscos e oportunidades ao longo de todo o ciclo;
                    - Ampliar o uso de simulações.
                    `,

                }
                break;
            default:
                text = {
                    level: "Otimizado",
                    result: `A organização possui um grande conhecimento do processo e este é bem definido na empresa. O foco está na melhoria contínua do desempenho, velocidade e eficiência do processo, por meio de otimização e aproveitamento de novas tecnologias. 
                    `,
                    advice: `- Identificar pontos de otimização no processo S&OP;
                    - Nesse estágio a organização tem potencial para buscar uma integração com clientes e fornecedores externo;
                    - Inclusão de ferramentas de Inteligência Artificial na previsão de demanda.
                    `,

                }
        }
    } else {
        switch (level) {
            case 0:
                text = {
                    level: "Iniciante",
                    result: `O conhecimento do processo S&OE na empresa ainda não foi desenvolvido. Sua empresa executa algumas atividades de forma descentralizada, sob influência das estrutura hierárquica em que ela se encontra.
                    `,
                    advice: `- Aumentar o conhecimento sobre a gestão de atendimento do cliente e seu nível de serviço;
                    - Estruturar uma célula de S&OE que desdobre os planos do S&OP, com uma equipe multifuncional que visa o nível de serviço do cliente.
                    `,
                }
                break;
            case 1:
                text = {
                    level: "Rudimentar",

                    result: `A organização possui os conhecimentos básicos do processo S&OE e executa algumas atividades do processo, porém com muita informalidade. Portanto ainda é preciso estruturar e implementar o processo de forma clara e bem definida na empresa, estabelecendo uma conexão com o S&OP.
                    `,
                    advice: `- Empoderar a célula de S&OE para garantir que suas decisões sejam executadas;
                    -Dar importância aos fóruns semanais que tomarão decisões, com a participação das áreas envolvidas nos processos.
                    `,
                }
                break;
            case 2:
                text = {
                    level: "Clássico",

                    result: `A organização possui bom conhecimento do processo S&OE, com algumas etapas já definidas e outras com potencial de implementação na empresa, incluindo maior colaboração entre as funções internas.
                    `,
                    advice: `- Obter a participação de todas as áreas relevantes para o processo;
                    - Priorizar as atividades do processo na agenda da organização;
                    - Garantir a qualidade das análises preparatórias e materiais utilizados nas reuniões;
                    - Desenvolver o senso crítico para extrair insights e identificar riscos e oportunidades para realizar tomadas de decisão no curto prazo;
                    - Ampliar a participação da área comercial com o processo de percepção da demanda (demand sensing) e incentivo a vendas (demand shapping) no curto prazo (mês corrente);
                    - Utilizar o painel do S&OE como base de dados para as discuções e decisões.
                    `,
                }
                break;
            default:
                text = {
                    level: "Otimizado",

                    result: `A organização possui um grande conhecimento do processo e este é bem definido na empresa. O foco está na melhoria contínua do desempenho, velocidade e eficiência do processo, por meio de otimização e aproveitamento de novas tecnologias. 
                    `,
                    advice: `- Identificar pontos de otimização no processo S&OE;
                    - Segmentar as células do S&OE para atender os diferentes grupos de clientes;
                    - Nesse estágio a organização deve promover a integração com clientes para monitorar o sell-out emtempo real;
                    - Visibilidade compartilhada com fornecedores para ampliar a responsividade da cadeia.
                    `,
                }
        }
    }
    return {
        level: text.level,
        result: text.result,
        advice: text.advice.split(';'),
    }
}

function getDimensionResultText(title, percentage) {
    let text = {};
    const level = percentage < 25 ? 0 : percentage < 50 ? 1 : percentage < 75 ? 2 : 3;
    switch (title.toUpperCase()) {
        case 'VISÃO E ESTRATÉGIA':
            switch (level) {
                case 0:
                    text = {
                        level: "Iniciante",
                        result: `O posicionamento estratégico da empresa ainda não está claro. O nível executivo foca no resultado de sua área preferencialmente.
                        `,
                        advice: `Executar o planejamento Estratégico e difundir o posicionamento da empresa para seus colaboradores. Tornar claro o diferencial da empresa e como se traduz no modelo de negócio.
                        `,
                    }
                    break;
                case 1:
                    text = {
                        level: "Rudimentar",
                        result: `O plano estratégico foi desenvolvido, a visão foi compartilhada para a empresa, porém as metas departamentais ainda direcionam a decisão.
                        `,
                        advice: `Promover a análise do ótimo global e não dar tanta atenção aos indicadores departamentais. Mapeie os trade-offs da empresa e garanta a efetividade do processo S&OP.
                        `,
                    }
                    break;
                case 2:
                    text = {
                        level: "Clássico",
                        result: `O posicionamento estratégico está definido e disseminado, e a empresa conhece os trade-off´s da cadeia.
                        `,
                        advice: `Crie modelos de tomada de decisão que conseguem balancear os trade-offs da empresa. Incentive a cultura de colaboração pelas lideranças.
                        `,
                    }
                    break;
                default:
                    text = {
                        level: "Otimizado",
                        result: `Os lançamentos de produtos e serviços, a ampliação da base de clientes, a precificação e promoções estão alinhadas com o planejaemtno da empresa, que tem o S&OP como processo chave.
                        `,
                        advice: `Implemente as demais camadas de gestão por horizonte temporal de decisão (da estratégia à execução) em um modelo integrado de gestão da cadeia de valor.
                        `,
                    }
            }
            break;
        case 'ALAVANCAS DE VALOR':
            switch (level) {
                case 0:
                    text = {
                        level: "Iniciante",
                        result: `Não existe uma clara correlação entre os processos, os projetos, as ações comerciais e o claro resultado financeiro da empresa.
                        `,
                        advice: `Definir as alavancas de valor e formas de medir seu efetivo impacto no resultado financeiro da empresa.
                        `,
                    }
                    break;
                case 1:
                    text = {
                        level: "Rudimentar",
                        result: `As alavancas de valor são definidas e desdobradas pelos departamentos da empresa, cada área é responsável pelo seu "pedaço de contribuição" com o resultado financeiro.
                        `,
                        advice: `Estabeleça uma visão de ótimo global considerando que as metas devem ser balanceadas entre as áreas.
                        `,
                    }
                    break;
                case 2:
                    text = {
                        level: "Clássico",
                        result: `As alavancas de valor estão identificadas, há uma discussão de trade-off, porém as metas ainda tem um caráter de desafio para cada área.
                        `,
                        advice: `Implemente um modelo de análise de resultado global e desenvolva cenários de simulação do resultado. Piore o resultado de uma área, se for necessário, pelo ótimo global.
                        `,
                    }
                    break;
                default:
                    text = {
                        level: "Otimizado",
                        result: `As alavancas de valor estão claras e balanceadas na empresa. O foco é na geração de valor para os clientes e otimização dos recursos físicos e financeiros, para ampliar o valor agregado da empresa (tangível e intangível ), medido pelo EVA.
                        `,
                        advice: `Mantenha oconceito de criação, otimização e proteção de valor vivo na empresa. Revise seus processos e elimine o que não gera mais valor para o cliente.
                        `,
                    }
            }
            break;
        case 'ORGANIZAÇÃO E CULTURA':
            switch (level) {
                case 0:
                    text = {
                        level: "Iniciante",
                        result: `O nível de conhecimento dos processos e técnicas de planejamento são baixos e podem comprometer o resultado da empresa.
                        `,
                        advice: `Capacite seus colaboradores nas melhores práticas funcionais de gestão, tanto para a área comercial, como para a área de operações.
                        `,
                    }
                    break;
                case 1:
                    text = {
                        level: "Rudimentar",
                        result: `O conhecimento está presente na empresa, porém ainda é muito focado em algumas pessoas. Os processos estão inicialmente estruturados, mas não existe uma governança dos mesmos.
                        `,
                        advice: `Amplie o conhecimento multifuncional de seus colaboradores, faça rotação de função e crie uma visão de cadeia de valor na empresa.
                        `,
                    }
                    break;
                case 2:
                    text = {
                        level: "Clássico",
                        result: `As pessoas tem um bom conhecimento de gestão da cadeia de valor, porém barreiras culturais impedem uma ação externa mais efetiva e ainda se verifica uma disputa por quem tem razão e quem tem culpa pelos problemas do dia a dia.
                        `,
                        advice: `Amplie a cultura de abertura mental e inovação. Coloque a colaboração e o desenvolvimento de lideranças como ação chave da empresa. Mude os layouts do trabalho e junte todo corpo executivo na mesma sala.
                        `,
                    }
                    break;
                default:
                    text = {
                        level: "Otimizado",
                        result: `A empresa tem uma cultura de colaboração e compartilhamento de responsabilidades. A organização funciona preferencialmente por projetos em grupos multifuncionais.
                        `,
                        advice: `Implemente o modelo de holocracia na empresa e ponha o foco em relações positivas de trabalho e confiança. Liberte o potencial criativo das pessoas com metas e responsabilidade, mas com o entendimento que falhar faz parte do processo e do aprendizado.
                        `,
                    }
            }
            break;
            case 'PROCESSOS':
                switch (level) {
                    case 0:
                        text = {
                            level: "Iniciante",
                            result: `A empresa está iniciando uma estruturação de processos. Existe pouca documentação e clareza dos processos de forma a auxiliar o colaborador.
                            `,
                            advice: `Iniciar a estruturação dos processos, de forma clara e em conjunto com os colaboradores, de forma a garantir qualidade de documentações e entendimento.
                            `,
                        }
                        break;
                    case 1:
                        text = {
                            level: "Rudimentar",
                            result: `Sua  empresa possui conhecimento da importância da estruturação, de forma clara e bem definida, dos processos executados pelos colaboradores. Ainda é preciso garantir esse conhecimento por meio de organização e documentação.
                            `,
                            advice: `Garantir o conhecimento de todos os processos, de forma clara, por meio de fluxos e documentações.
                            `,
                        }
                        break;
                    case 2:
                        text = {
                            level: "Clássico",
                            result: `A empresa possui boa estrutura em processos, com documentação e atualização necessária.
                            `,
                            advice: `Aumentar a visão abrangente do negócio e implementar melhorias que afetam a eficiência dos processos.
                            `,
                        }
                        break;
                    default:
                        text = {
                            level: "Otimizado",
                            result: `Existe um nível alto de conhecimento sobre as atividades, há um gerenciamento eficaz, controle e automatização dos seus processos, garantindo eficiência nos resultados.
                            `,
                            advice: `Garantir a governança de processos, com identificação e implementação de melhorias e atualizações periódicas.
                            `,
                        }
                }
                break;
                case 'DESENVOLVIMENTO HUMANO':
                    switch (level) {
                        case 0:
                            text = {
                                level: "Iniciante",
                                result: `Os colaboradores possuem baixo conhecimento do processo em que atuam, executando as atividades sem clareza no impacto do negócio.
                                `,
                                advice: `Aumentar o nível de conhecimento dos colaboradores por meio de treinamentos estruturados, visando a clareza do processo e seu impacto no negócio.
                                `,
                            }
                            break;
                        case 1:
                            text = {
                                level: "Rudimentar",
                                result: `Os colaboradores possuem conhecimento básico do processo em que atuam. Ainda falta clareza do impacto de suas atividades no negócio.
                                `,
                                advice: `Aumentar o nível de conhecimento dos colaboradores por meio de treinamentos estruturados, visando a clareza do processo, seu impacto no negócio e iniciar o desenvolvimento da capacidade de identificação de melhorias no processo.
                                `,
                            }
                            break;
                        case 2:
                            text = {
                                level: "Clássico",
                                result: `Os colaboradores possuem bom conhecimento do processo em que atuam, com certa clareza do impacto que suas atividades exercem sobre as tomadas de decisão da empresa.
                                `,
                                advice: `Aumentar o conhecimento do colaborador por meio do desenvolvimento de materiais a respeito da lógica de processo, assim permitindo o desenvolvimento da capacidade de efetuar análises no processo e identificar pontos de melhoria.
                                `,
                            }
                            break;
                        default:
                            text = {
                                level: "Otimizado",
                                result: `Os colaboradores possuem alto conhecimento processo em que atuam, com clareza do impacto que suas atividades exercem sobre as tomadas de decisão da empresa e capacidade de identificar pontos de melhorias no processo.
                                `,
                                advice: `Otimizar a capacidade de identificação de melhorias no processo.
                                `,
                            }
                    }
                    break;
                    case 'DADOS E TECNOLOGIA':
                        switch (level) {
                            case 0:
                                text = {
                                    level: "Iniciante",
                                    result: `O uso de sistemas de informação é quase inexistente, gerando atividades manuais e repetitivas, baixa qualidade dos dados e, consequentemente, afeta a análise para tomadas de decisão.
                                    `,
                                    advice: `Iniciar a implementação gradual de sistemas na etapas operacionais e repetitivas do processo, garantindo maior confiabilidade dos dados.
                                    `,
                                }
                                break;
                            case 1:
                                text = {
                                    level: "Rudimentar",
                                    result: `Existem sistemas utilizados em algumas etapas do processo, mas ainda há excesso de atividades manuais com apoio de planilhas, gerando baixa confiabilidade de dados.
                                    `,
                                    advice: `Reduzir o número de atividades manuais e repetitivas, por meio da implementação de sistemas e tecnologia no decorrer de todo o processo.
                                    `,
                                }
                                break;
                            case 2:
                                text = {
                                    level: "Clássico",
                                    result: `Existe o uso de sistemas em boa parte dos processos, o que aumenta a qualidade dos dados e permite uma melhor análise para a tomada de decisões.
                                    `,
                                    advice: `Aumentar a automatização dos processos operacionais, garantindo maior qualidade de dados e permitindo maior dedicação do colaborador para realizar análises.
                                    `,
                                }
                                break;
                            default:
                                text = {
                                    level: "Otimizado",
                                    result: `O uso de sistemas nos processos é uma preocupação da empresa, que entende que a utilização de tecnologias garante qualidade de dados, análise de causa raiz e consistência na tomada de decisões.
                                    `,
                                    advice: `Buscar e identificar novas tecnologias para otimizar a velocidade e eficiência dos processos, garantindo a qualidade de dados para a tomada de decisões.
                                    `,
                                }
                        }
                        break;
        default: //INDICADORES E METAS
            switch (level) {
                case 0:
                    text = {
                        level: "Iniciante",
                        result: `A utilização de indicadores não é presente na organização, o que inviabiliza/prejudica a identificação de desvios e, análise de causa raiz e definição de planos de ação.
                        `,
                        advice: `Iniciar o desenvolvimento de indicadores na empresa, para permitir a identificação de desvios, análise de causa raiz e definição de planos de ação.
                        `,
                    }
                    break;
                case 1:
                    text = {
                        level: "Rudimentar",
                        result: `Existem alguns indicadores e estes são desenvolvidos e utilizados apenas em situações críticas, ou seja, não existe análise recorrente com identificação de causa raiz e definição de planos de ação.
                        `,
                        advice: `Garantir a análise recorrente dos indicadores, permitindo a identificação de desvios, análise de causa raiz e definição de planos de ação.
                        `,
                    }
                    break;
                case 2:
                    text = {
                        level: "Clássico",
                        result: `Existem indicadores em algumas etapas do processo, com análise recorrentes, porém a análise de causa raiz e definição de plano de ação ainda precisa ser implementada.
                        `,
                        advice: `Implementar a análise de causa raiz a partir dos indicadores e definir planos de ação para os desvios identificados.
                        `,
                    }
                    break;
                default:
                    text = {
                        level: "Otimizado",
                        result: `Os indicadores são amplamente utilizados em todas/ várias etapas do processo, com análises recorrentes que auxiliam na tomada de decisões, e análises de causa raiz para definição de planos de ação.
                        `,
                        advice: `Otimizar indicadores já existentes por meio da implementação de novas tecnologias.
                        `,
                    }
                    break;
            }
    }

    return {
        level: text.level,
        result: text.result,
        advice: text.advice
    }
}



export { getStepResultText, getDimensionResultText }